import { gql } from '@apollo/client';

export const HOSTS = gql`
  query hostsStatuses {
    hostsOverview {
      id
      online
      in_service
      client_sessions {
        id
      }
      shell_mode
      user {
        roles {
          alias
        }
      }
    }
  }
`;
